import { useState } from 'react';
import { createCalendar, getCalendarDefaultState } from '../data/calendar';
import CalendarForm from '../components/calendar-form';
import { Alert } from 'react-bootstrap';
import TopNav from '../components/top-nav';

const CalendarNewRoute = () => {
    const [showAlert, setShowAlert] = useState(false);
    const [variant, setVariant] = useState('');
    const [message, setMessage] = useState('');
    const [calendar, setCalendar] = useState(getCalendarDefaultState());
    const handleChange = (newCalendar) => setCalendar(newCalendar);
    const previousItems = [
        {
            label: 'Calendars',
            link: '/admin/calendars'
        }
    ];
    const handleError = (e) => {
        setMessage(e.toString());
        setVariant('danger');
        setShowAlert(true);
    };

    const handleSubmit = () => {
        createCalendar(calendar).then(data => {
            setMessage(<>The calendar has been saved. Click <a href="/admin/calendars">here</a> to go back to the calendar listing page.</>);
            setVariant('success');
            setShowAlert(true);
            window.scrollTo(0, 0);
        }).catch(e => {
            handleError(e);
        });
    };

    return (
        <>
          <TopNav activeItem="New Calendar" previousItems={previousItems} />
            <h1>New Calendar</h1>
            <Alert show={showAlert} variant={variant}>{message}</Alert>
            <CalendarForm
                calendar={calendar}
                handleStateChange={handleChange}
                handleSubmit={handleSubmit}
                errorCallback={handleError}
            />
        </>
    );
};

export default CalendarNewRoute;
